import { Search } from 'lucide-react'

import { CheckinLayout } from './CheckinLayout'
import { SelectionCard } from './SelectionCard'
import { StepHeader } from './StepHeader'
import type { GuestItem } from './types'

interface GroupStepProps {
  onBack: () => void
  groupSearch: string
  onGroupSearchChange: (val: string) => void
  isFetching: boolean
  filteredGroups: string[]
  sideGuests: GuestItem[]
  onSelectGroup: (group: string) => void
  onSearchAll: () => void
}

export function GroupStep({
  onBack,
  groupSearch,
  onGroupSearchChange,
  isFetching,
  filteredGroups,
  sideGuests,
  onSelectGroup,
  onSearchAll,
}: GroupStepProps) {
  return (
    <CheckinLayout>
      <StepHeader
        title="เลือกกลุ่มของคุณ"
        onBack={onBack}
      />

      <div className="relative mb-4">
        <Search className="text-foreground/40 absolute top-1/2 left-3 size-4 -translate-y-1/2" />
        <input
          type="text"
          aria-label="ค้นหากลุ่ม"
          placeholder="ค้นหากลุ่ม..."
          value={groupSearch}
          onChange={(e) => onGroupSearchChange(e.target.value)}
          className="border-border focus:ring-primary/20 w-full rounded-2xl border bg-white/50 py-2.5 pr-4 pl-9 text-sm outline-none focus:ring-2"
        />
      </div>

      {isFetching ? (
        <div className="py-12 text-center opacity-50">กำลังโหลด...</div>
      ) : filteredGroups.length === 0 ? (
        <div className="py-12 text-center opacity-50">ไม่พบกลุ่ม</div>
      ) : (
        <div className="space-y-3">
          {filteredGroups.map((group) => {
            const count = sideGuests.filter((g) => g.group === group).length
            return (
              <SelectionCard
                key={group}
                label={group}
                sublabel={`${count} คน`}
                onClick={() => onSelectGroup(group)}
              />
            )
          })}
        </div>
      )}

      <button
        type="button"
        onClick={onSearchAll}
        className="text-foreground/50 mt-6 flex w-full items-center justify-center gap-2 py-3 text-sm transition-all hover:opacity-80 active:scale-[0.98]"
      >
        <Search className="size-4" />
        ไม่แน่ใจ? ค้นหาจากทั้งหมด
      </button>
    </CheckinLayout>
  )
}
